import { supabase } from "@/integrations/supabase/client";

const VISITOR_KEY = "wekit-visitor-id";

function visitorId(): string {
  try {
    let id = localStorage.getItem(VISITOR_KEY);
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem(VISITOR_KEY, id);
    }
    return id;
  } catch {
    return crypto.randomUUID();
  }
}

/** Write one consent record. Failures are logged, never block the visitor. */
export async function recordConsent(input: {
  kind: "cookies" | "policy";
  policy: string;
  choice: "accepted" | "rejected" | "agreed" | "custom";
  analytics?: boolean;
  version?: string;
}) {
  const { data } = await supabase.auth.getSession();
  const { error } = await supabase.from("policy_consents").insert({
    user_id: data.session?.user.id ?? null,
    visitor_id: visitorId(),
    kind: input.kind,
    policy: input.policy,
    choice: input.choice,
    analytics: input.analytics ?? false,
    version: input.version ?? "v1",
    user_agent: navigator.userAgent.slice(0, 400),
  });
  if (error) console.warn("consent_record_failed", error.message);
  return !error;
}
